export const sumOfArray = <Item = number>(
  array?: Item[],
  callback = (acc: number, cur: Item) => acc + (cur as number),
) => array?.reduce<number>(callback, 0) || 0
